
import { Vue, Component, Prop } from 'vue-property-decorator';
import { component as Viewer } from 'v-viewer';
import { $delay } from '@/common/utils/index';
import UserService from '@/services/user.service';
import lazyInject from '@/di';
import { BASE_URL } from '@/common/constant';
import ShopService from '@/services/shop.service';

@Component({
  components: {
    Viewer,
  },
})
export default class CertificateDrawer extends Vue {
  visible = false;

  BASE_URL = BASE_URL;

  @lazyInject(UserService)
  protected userService!: UserService;

  @lazyInject(ShopService)
  shopService!: ShopService;

  @Prop()
  shopId!: number;

  fileList: any[] = [];

  uploading = false;

  token: any = '';

  async init() {
    const res = await this.shopService.getHoldingIdPhoto({
      shopId: this.shopId,
    });
    this.fileList = res;
    console.log(res);
    this.visible = true;
    this.token = this.userService.currentUser()?.token;
  }

  onClose() {
    this.fileList = [];
    this.visible = false;
  }

  async onSubmit() {
    const data = {
      shopId: this.shopId,
      holdingIdPhotoId: this.fileList.map((item) => item.id).join(','),
    };
    const res = await this.shopService.updateHoldingIdPhoto(data);
    if (res) {
      this.$message.success('操作成功');
      this.onClose();
    }
  }

  delectImg(id: number) {
    this.fileList = this.fileList.filter((item) => item.id !== id);
  }

  async onChangeImg(info: any) {
    // console.log(info);
    if (info.file.status === 'uploading') {
      this.uploading = true;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response;
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } else {
        this.$message.error(error);
      }
    }
    if (info.file.status === 'done') {
      const { data } = JSON.parse(info.file.xhr.response);
      const headlineImage = {
        id: data[0]?.id,
        uid: data[0]?.id,
        url: data[0]?.url,
        name: 'mage.png',
        status: 'done',
      };
      this.fileList.push(headlineImage);
      this.uploading = false;
    }
    if (info.file.status === 'removed') {
      if (info.file.xhr) {
        const { data } = JSON.parse(info.file.xhr.response);
        const id = data[0]?.id;
        this.fileList = this.fileList.filter((res: { id: any }) => {
          return res.id !== id;
        });
      } else {
        // console.log(info.file);
        const { id } = info.file;
        this.fileList = this.fileList.filter((res: { id: any }) => {
          return res.id !== id;
        });
      }
    }
  }
  beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error('请上传 png/jpeg 格式的照片!');
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      this.$message.error('照片必须小于5MB!');
    }

    return isJpgOrPng && isLt5M;
  }
}
